"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactCard = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const IconEdit_1 = require("../../icons/IconEdit");
const ContactFormModal_1 = require("../../contact-form-modal/ContactFormModal");
const ContactCard = (props) => {
    var _a;
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    function showContactFormModal() {
        showModal(react_1.default.createElement(ContactFormModal_1.ContactFormModal, { contact: props.booking.contact, onClose: hideModal, onOk: (contact) => {
                props.onBookingChange({ contact });
                hideModal();
            } }));
    }
    // Validate.
    (0, react_1.useEffect)(() => {
        // Just check if the name is present. The rest of the validation
        // is done by the contact form modal.
        let invalid = false;
        if (!props.booking.contact || !props.booking.contact.name) {
            invalid = true;
        }
        if (props.isInvalid !== invalid) {
            props.isInvalidChange(invalid);
        }
    }, [props.booking.contact]);
    const invalidClass = props.isInvalid ? "text-danger" : "";
    return (react_1.default.createElement(Card_1.default, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "" },
        react_1.default.createElement(Card_1.default.Body, { className: "row" },
            react_1.default.createElement("dl", { className: "col-sm-6 col-lg-12" },
                props.editable && (react_1.default.createElement(Button_1.default, { className: "float-right no-print", variant: "light", size: "sm", onClick: showContactFormModal },
                    react_1.default.createElement(IconEdit_1.IconEdit, null),
                    " Edit")),
                react_1.default.createElement("dt", { className: invalidClass }, "Organisation"),
                react_1.default.createElement("dd", null, props.booking.contact.org ? (react_1.default.createElement("strong", null, props.booking.contact.org)) : ("---")),
                react_1.default.createElement("dt", { className: invalidClass }, "Kontaktperson"),
                react_1.default.createElement("dd", null,
                    react_1.default.createElement("strong", null, props.booking.contact.name),
                    react_1.default.createElement("br", null),
                    props.booking.contact.email,
                    react_1.default.createElement("br", null),
                    props.booking.contact.phone)),
            react_1.default.createElement("dl", { className: "col-sm-6 col-lg-12" },
                react_1.default.createElement("dt", { className: invalidClass }, "Adresse"),
                react_1.default.createElement("dd", { className: "text-pre-line" },
                    props.booking.contact.getAddressBlock({
                        includeOrg: false,
                        includeName: false,
                    }),
                    props.booking.contact.isLegacyAddress() && (react_1.default.createElement("p", { className: "text-warning italics" },
                        "Altes Format \u2192",
                        " ",
                        react_1.default.createElement("a", { href: "#", onClick: (e) => {
                                showContactFormModal();
                                e.preventDefault();
                            } }, "Adresse aktualisieren")))))),
        modal));
};
exports.ContactCard = ContactCard;
